module.exports = __webpack_public_path__ + "img/starter.68dee327.png";